<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input *ngIf="travelWageId === '+'" ttLabel="travelwage_id" [(ttModel)]="edit.travelwage_id"></tt-input>
        <tt-input *ngIf="travelWageId !== '+'" ttLabel="travelwage_id" [ttModel]="edit.travelwage_id" ttReadonly></tt-input>
        <tt-input ttLabel="travelwage_name" [(ttModel)]="edit.travelwage_name" ttRequired></tt-input>
        <tt-select ttLabel="travelwagetype" [(ttModel)]="edit.travelwagetype_id" [ttData]="selectListTravelWageTypes" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-input ttLabel="account_no" [ttModel]="edit.account_no" ttReadonly></tt-input>
        <tt-search ttLabel="account_name" [(ttModel)]="edit.account_name" [ttSearch]="searchAccountNames" (ttOnSelected)="onAccountNameSelected($event)" (ttOnClear)="onAccountNameSelected()"></tt-search>
        <tt-button-save ttText="travelwage_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
